
// const ApiBaseURL = 'http://192.168.167.5:8970/dashboard/v1';
// const ApiBaseURL = 'http://192.168.167.5:8971/dashboard/v1';
// const ApiBaseURL = 'https://track-dev-api.altruistindia.com';
const ApiBaseURL = 'https://track-api.altruistindia.com';

export default ApiBaseURL;